var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRound2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3799,
    cy: 14.5896,
    r: 14,
    fill: "#1CBEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50159 16.3396L10.0016 18.8396M13.5016 14.8396L16.0016 12.3396M11.5016 16.3396L14.0016 18.8396L20.0016 12.3396",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRound2);
export default __webpack_public_path__ + "static/media/check-round-2.ef50855dd7d20149f7e819f6b463c7e6.svg";
export { ForwardRef as ReactComponent };